export const reduxKey = '@@SellerModal.Initialization';
